import {
  AtomIcon,
  BlocksIcon,
  CircleHelpIcon,
  CpuIcon,
  FlaskConicalIcon,
  ListChecksIcon,
  type LucideIcon,
  PackageIcon,
} from "lucide-react";

export interface NavItem {
  to: "/algorithms" | "/devices" | "/experiments" | "/tasks" | "/sdk" | "/help" | "/dev/components";
  label: string;
  icon: LucideIcon;
}

export const PRIMARY_NAV: readonly NavItem[] = [
  { to: "/algorithms", label: "算法广场", icon: AtomIcon },
  { to: "/devices", label: "设备管理", icon: CpuIcon },
  { to: "/experiments", label: "量子实验", icon: FlaskConicalIcon },
  { to: "/tasks", label: "任务管理", icon: ListChecksIcon },
  { to: "/sdk", label: "SDK 中心", icon: PackageIcon },
  ...(true
    ? [{ to: "/dev/components", label: "组件", icon: BlocksIcon } as const]
    : []),
];

export const HELP_NAV: NavItem = { to: "/help", label: "使用帮助", icon: CircleHelpIcon };

export const DEFAULT_HOME = "/algorithms" satisfies NavItem["to"];
